import { render } from "./NotAuthorized.vue?vue&type=template&id=b2fd1b44&scoped=true"
import script from "./NotAuthorized.vue?vue&type=script&lang=js"
export * from "./NotAuthorized.vue?vue&type=script&lang=js"

import "./NotAuthorized.vue?vue&type=style&index=0&id=b2fd1b44&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2fd1b44"]])

export default __exports__